import { jsx as _jsx } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { T } from '@sm/intl';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import getStatus from './lib';
export const COPY = {
  title: {
    id: 'OpenEndedCoding.TrainingFlow.title',
    defaultMessage: 'Review keywords',
    description: '[Type: Header][Vis: med] - Header for open ended coding view keywords selection'
  },
  titleExtracting: {
    id: 'OpenEndedCoding.TrainingFlow.titleExtracting',
    defaultMessage: 'Extracting keywords',
    description: '[Type: Header][Vis: med] - Header for open ended coding view keywords extraction'
  },
  titleTagging: {
    id: 'OpenEndedCoding.TrainingFlow.titleTagging',
    defaultMessage: 'Auto-tagging',
    description: '[Type: Header][Vis: med] - Header for open ended coding auto tagging'
  }
};
const useStyles = createUseStyles(theme => {
  const border = `2px solid ${theme.palette.border.main}`;
  return {
    header: {
      borderBottom: border,
      display: 'flex',
      padding: `${theme.spacing[6]}px ${theme.spacing[7]}px`
      // justifyContent: 'center',
    }
  };
});

const Header = ({
  status
}) => {
  const classes = useStyles();
  const {
    isTagging,
    isExtracting
  } = getStatus(status);
  return _jsx(Box, {
    className: classes.header,
    children: _jsx(Typography, {
      component: "h4",
      variant: "sectionTitle",
      children: _jsx("strong", {
        children: isTagging ? _jsx(T, {
          desc: COPY.titleTagging
        }) : isExtracting ? _jsx(T, {
          desc: COPY.titleExtracting
        }) : _jsx(T, {
          desc: COPY.title
        })
      })
    })
  });
};
export default Header;